import Service from '../Service'
import {http} from '../config'

export default class PessoalService extends Service{

    constructor(){
        super('pessoal');
    }

    Relatorio(vincularProjeto, cargo, idProjeto, idTipoProjeto, tipoRegime, ativo, etnia, escolaridade, sexo, adesaoInicial, adesaoFinal){
        return http.get(this.getNomeControle() + "/Relatorio", {
            params: {
                vincularProjeto,
                cargo, 
                idProjeto,
                idTipoProjeto,
                tipoRegime,
                ativo,
                etnia,
                escolaridade,
                sexo,
                adesaoInicial,
                adesaoFinal
            }
        })
    }
    
    AutoComplete(q){
        return http.get(this.getNomeControle() + "/AutoComplete?q=" + q);
    }

    VerificarExistente(cpfCnpj) {
        return http.get(this._nomeControle + "/VerificarExistente", {
            params: {
                cpfCnpj
            }
        });
    }

    Totalizadores(search, columns, filter){
        let parametros = this.GetParamentroPaginacaoOrdenacao(null, null, null, [], search, columns);

        if(filter){
            parametros += `&$filter=${filter}`;
        }

        if(parametros === '?'){
            parametros = '';
        }

        return http.get(`${this._nomeControle}/Totalizadores${parametros}`);
    }

    ObterComUsuario(){
        return http.get(this.getNomeControle() + "/ObterComUsuario");
    }

    Aniversariantes(){
        return http.get(`${this._nomeControle}/Aniversariantes`);
    }
  }
